import React, { useEffect, useState } from "react";
import { Col, Form, InputGroup, ListGroup, Modal, Row } from "react-bootstrap";
import { AiOutlineEnter } from "react-icons/ai";
import { FaSearch } from "react-icons/fa";
import { HiXMark } from "react-icons/hi2";
import { useAuthState } from "../../context/AuthContext";
import { useParams } from "react-router-dom";
import EnergoTooltip from "../shared/EnergoTooltip";

/**
 * 
 * @param {param} openTickets array of Ticket objects 
 * @param {param} closedTickets array of Ticket objects 
 * @param {param} setSelectedTicket setter for ticket in view
 * @param {param} setFilteredOpenTickets array of filtered open tickets
 * @param {param} setFilteredClosedTickets array of filtered open tickets
 */
const TicketUserFilter = ({openTickets, closedTickets, setSelectedTicket, setFilteredOpenTickets, setFilteredClosedTickets}) => {

    const { ticket_id } = useParams() || undefined; // url parameter
    const { user, contactPerson, tooltips, tooltipsTrigger } = useAuthState(); // logged User
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [allTicketUsers, setAllTicketUsers] = useState([]);
    const [searchModal, setSearchModal] = useState(false);
    const [searchField, setSearchField] = useState("");


    // init effect
    useEffect(() => {
        var userArr = [];
        if (contactPerson && contactPerson !== null && (ticket_id === null || ticket_id === undefined) ) {
            setSelectedUsers([contactPerson]);
        }
    
        // if open tickets exist
        if (openTickets.length > 0) {
            openTickets.forEach(ticket => {
                var ticket_user = {id: ticket.partner_id[0], name: ticket.partner_id[1], tickets: 0};
                openTickets.map(ot => {
                    if (ot.partner_id[0] === ticket_user.id) return ticket_user.tickets += 1;
                });
                if (closedTickets.length > 0) {
                    closedTickets.map(ct => {
                        if (ct.partner_id[0] === ticket_user.id) return ticket_user.tickets += 1;
                    });
                }
                if (ticket_user.name.includes(`${user.name}, `)) {
                    ticket_user.name = ticket_user.name.split(`${user.name}, `)[1]
                }
                var index = userArr.findIndex(i => i.id === ticket_user.id);
                if (index === -1) userArr.push(ticket_user);
            });
        }

        // if closed tickets exist
        if (closedTickets.length > 0) {
            closedTickets.forEach(ticket => {
                var ticket_user = {id: ticket.partner_id[0], name: ticket.partner_id[1], tickets: 0};
                if (ticket_user.name.includes(`${user.name}, `)) {
                    ticket_user.name = ticket_user.name.split(`${user.name}, `)[1];
                }
                var index = userArr.findIndex(i => i.id === ticket_user.id);
                if (index === -1) {
                    userArr.push(ticket_user);
                }
            });
        }
        setFilteredUsers(userArr);
        setAllTicketUsers(userArr);
        filterTicketsHandler();

    }, [openTickets, closedTickets])

    // effect when selected user has been added/removed
    useEffect(() => {
        filterTicketsHandler();
    }, [selectedUsers])


    useEffect(() => {
        if (searchField.length > 0) {
            setFilteredUsers(allTicketUsers.filter(u => u.name.toLowerCase().includes(searchField.toLowerCase())));
        } else {
            setFilteredUsers(allTicketUsers);
        }
    }, [searchField])
    

    
    // function to filter tickets of selected user
    const filterTicketsHandler = () => {
        var filteredOpenArr = [];
        var filteredClosedArr = [];

        if (openTickets.length > 0) {
            if (selectedUsers.length > 0) {
                selectedUsers.forEach(user => {
                    filteredOpenArr = [...filteredOpenArr, ...openTickets.filter(ot => ot.partner_id[0] === user.id)];
                });
                setSelectedTicket(filteredOpenArr[0]);
            } else {
                filteredOpenArr = openTickets;
                if (ticket_id !== null && ticket_id !== undefined) {
                    var param_ticket = openTickets.filter(ot => ot.id === Number(ticket_id));
                    if (param_ticket.length > 0) setSelectedTicket(param_ticket[0]);
                    else {
                        param_ticket = closedTickets.filter(ct => ct.id === Number(ticket_id));
                        if (param_ticket.length > 0) setSelectedTicket(param_ticket[0])
                    }
                } else {
                    setSelectedTicket(openTickets[0]);
                }
            }
        }

        if (closedTickets.length > 0) {
            if (selectedUsers.length > 0) {
                selectedUsers.forEach(user => {
                    filteredClosedArr = [...filteredClosedArr, ...closedTickets.filter(ct => ct.partner_id[0] === user.id)];
                })
            } else {
                filteredClosedArr = closedTickets;
            }
        }
        setFilteredOpenTickets(filteredOpenArr);
        setFilteredClosedTickets(filteredClosedArr);
    }


    // function to remove user from selected 
    const removeSelectedUserHandler = (user) => {
        if (selectedUsers.includes(user)) {
            var tmpArr = selectedUsers.filter(se => se.id !== user.id);
            setSelectedUsers(tmpArr);
        }
    }

    // function to add user to selected
    const addSelectedUserHandler = (user) => {
        var index = selectedUsers.findIndex(su => su.id === user.id);
        if (index === -1) {
            setSelectedUsers(selected => [...selected, user]);
        }
        setSearchField("");
        setSearchModal(false);
    }

    return (
        <>
            <div style={{display: "flex"}}>
                <InputGroup style={{marginRight: 10}}>
                    <InputGroup.Text 
                        style={{ background: "white", borderTopLeftRadius: "12px", borderBottomLeftRadius: "12px" }}
                    >
                        <FaSearch />
                    </InputGroup.Text>
                    <Form.Control
                        id="search-field"
                        onClick={() => setSearchModal(true)}
                        onChange={() => setSearchModal(true)}
                        value=""
                        size="sm"
                        placeholder={`Nach Namen suchen ${navigator.userAgent !== undefined && navigator.userAgent.includes("Macintosh") ? '(Cmd + k)' : '(Strg + k)'}`}
                        style={{ borderTopRightRadius: "12px", borderBottomRightRadius: "12px" }} />
                </InputGroup>
                <EnergoTooltip tKey="7001" position="right" />
            </div>
            <br />
            {selectedUsers.length > 0 ?
                selectedUsers.map(selUser => (
                    <>
                        <a 
                            className="link-energo"
                            key={selUser.id}
                            href={`/filter/${selUser.name}`}
                            onClick={e => {e.preventDefault(); removeSelectedUserHandler(selUser);}}
                        >
                            <HiXMark /> {selUser.name}
                        </a>
                        <br/>
                    </>
                ))
            : null}

            <Modal show={searchModal} onHide={() => setSearchModal(false)}>
                <Modal.Body>
                    <Row>
                        <Col xs="12">
                            <InputGroup size="lg">
                                <InputGroup.Text style={{background: "white"}}><FaSearch /></InputGroup.Text>
                                <Form.Control
                                    onChange={e => setSearchField(e.target.value)}
                                    value={searchField}
                                    placeholder="Name eingeben"
                                    autoFocus
                                />
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col xs="12" className="text-center">
                            {searchField === ""? 
                                <small className="text-muted">Geben Sie den Namen oder Nachname des Benutzers ein.</small>
                            :
                                filteredUsers.length > 0 ?
                                    <ListGroup>
                                        {filteredUsers.map(u => (
                                            <ListGroup.Item 
                                                action 
                                                onClick={() => addSelectedUserHandler(u)} 
                                                key={`search:${u.id}`}
                                            >
                                                <Row className="align-items-center text-center">
                                                    <Col xs="10" className="text-start">
                                                        {u.name} &nbsp;
                                                        <small style={{fontSize: "12px"}} className="text-energo">
                                                            <b>
                                                                {u.tickets}&nbsp; 
                                                                {u.tickets === 1? "Ticket":"Tickets"}
                                                            </b>
                                                        </small>
                                                    </Col>
                                                    <Col xs="2" className="text-end">
                                                        <AiOutlineEnter size={30} />
                                                    </Col>
                                                </Row>
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                :
                                <small className="text-muted">Keine Übereinstimmung</small>
                            }
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default TicketUserFilter;